import React from "react";
import xmlFormatter from "xml-formatter";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";

const XMLViewer = ({ xmlString }) => {
  const formattedXML = xmlFormatter(xmlString, {
    indentation: "  ", // Indent with spaces
    lineSeparator: "\n", // Ensure a new line after each tag
  });

  return (
    <SyntaxHighlighter
      language="xml"
      style={darcula}
      customStyle={{
        backgroundColor: "transparent",
        //   whiteSpace: "pre-wrap", // Keeps line breaks
        //   wordBreak: "break-word", // Prevents overflow
        //   overflowX: "hidden", // No horizontal scrolling
      }}>
      {formattedXML}
    </SyntaxHighlighter>
  );
};

export default XMLViewer;
